import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const uploadEmailTemplateBannerImage: (
  fetchContext: FetchContext,
  programId: number,
  attachmentFile: File,
  accessToken?: string,
) => Promise<string> = (fetchContext, programId, attachmentFile, accessToken) => {
  const formData = new FormData();
  formData.append('bannerImage', attachmentFile);

  return fetch(
    `${fetchContext.baseUrl}/api/staff/programs/${programId}/email-templates/banner-image`,
    {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    },
  ).then((response) => responseErrorHandler<string>(fetchContext.errorStore, response, 'upload email template banner image', false));
};
